import { useEffect } from "react";
import { Button, Layout, Tooltip } from "antd";
import { GeneralStore } from "../stores";
import { useNavigate } from "react-router-dom";
import { getSidebarLabelByValue } from "../helper";
import { SidebarItems } from "./constants/SidebarData";
import { Logo, ProfileDropdown, LanguageSwitcher } from "../sharedComponents";
import { LeftOutlined, MenuOutlined } from "@ant-design/icons";
import { useInnerWidth } from "../hooks";

const { Header } = Layout;

export const Title = () => {
  const navigate = useNavigate();
  const sidebarData = SidebarItems();
  const innerWidth = useInnerWidth();
  const currentPath = window.location.pathname;
  const {
    pageTitle,
    setPageTitle,
    setMobileSidebarOpen,
    contentPadding,
    setContentPadding,
  } = GeneralStore();

  useEffect(() => {
    setPageTitle(getSidebarLabelByValue(currentPath, sidebarData));
    if (!contentPadding) setContentPadding(true);
  }, [currentPath]);

  const displayTitle =
    innerWidth < 640
      ? pageTitle.length > 11
        ? pageTitle.slice(0, 15) + "..."
        : pageTitle
      : pageTitle.length > 30
      ? pageTitle.slice(0, 34) + "..."
      : pageTitle;

  return (
    <Header className="!bg-transparent !px-5 !py-3.5 flex items-center justify-between !h-auto !leading-normal">
      <div className="flex items-center gap-2 min-w-0">
        <Button
          size={innerWidth < 640 ? "small" : "middle"}
          type="text"
          onClick={() => navigate(-1)}
          icon={<LeftOutlined />}
          className="!text-[#64748B] hover:!text-[#334155]"
        />
        <Tooltip title={pageTitle}>
          <h1 className="spor-topbar-title text-base sm:text-lg md:text-xl truncate max-w-[200px] sm:max-w-none">
            {displayTitle}
          </h1>
        </Tooltip>
      </div>

      <div className="md:hidden flex items-center gap-1">
        <LanguageSwitcher size="small" />
        <Button
          type="text"
          size="large"
          icon={<MenuOutlined />}
          onClick={() => setMobileSidebarOpen(true)}
        />
        <Logo size="sm" className="h-9 w-auto max-w-[88px]" />
      </div>

      <div className="hidden md:flex items-center gap-1">
        <LanguageSwitcher />
        <ProfileDropdown />
      </div>
    </Header>
  );
};
